import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { HankoSignup } from "../components/HankoSignup";
import { useAuth } from "../context/AuthContext";
import "../styles/hanko.css";

export function Signup() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <span className="material-symbols-outlined text-4xl animate-spin text-primary">progress_activity</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen p-4 bg-background">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="flex items-center gap-3">
            <div className="size-12 flex items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-lg">
              <span className="material-symbols-outlined text-3xl">deployed_code</span>
            </div>
            <div>
              <h1 className="text-2xl font-black tracking-tight">BuildCrate</h1>
              <p className="text-xs text-muted-foreground">buildcrate.games</p>
            </div>
          </div>
        </div>

        {/* Card */}
        <div className="bg-card border border-border rounded-xl shadow-lg p-8">
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold mb-2">Create an Account</h2>
            <p className="text-muted-foreground">Sign up to start building your games</p>
          </div>

          <HankoSignup />

          <p className="text-center text-sm text-muted-foreground mt-6">
            Already have an account?{" "}
            <Link to="/login" className="text-primary font-medium hover:underline">
              Sign in
            </Link>
          </p>
        </div>

        <p className="text-center text-xs text-muted-foreground mt-6">
          By signing up, you agree to our Terms of Service and Privacy Policy
        </p>
      </div>
    </div>
  );
}
